<template>
  <div id="actioncable-status">
    <template v-if="connect_status == consts.ACTION_CABLE.DIS_CONNECTED || connect_status == consts.ACTION_CABLE.NON_TARGET">
      <div class="pg-admissionlist__action_cable_status__status">
        <template v-if="connect_status == consts.ACTION_CABLE.DIS_CONNECTED">
          <div v-on:click="reload" class="pg-admissionlist__action_cable_status__wrap clickable">
            <img v-bind:src="require('assets/images/synchronize_start_navy.png')" :class="{ 'pg-admissionlist__action_cable_status__icon__synchronizing': is_click_icon }" class="pg-admissionlist__action_cable_status__status-icon" />
            <span class="pg-admissionlist__action_cable_status__action-cable-label">同期開始</span>
          </div>
        </template>
        <template v-else-if="connect_status == consts.ACTION_CABLE.NON_TARGET">
          <div v-on:click="reload" class="pg-admissionlist__action_cable_status__wrap clickable">
            <img v-bind:src="require('assets/images/synchronize_start_navy.png')" :class="{ 'pg-admissionlist__action_cable_status__icon__synchronizing': is_click_icon }" class="pg-admissionlist__action_cable_status__status-icon" />
            <span class="pg-admissionlist__action_cable_status__action-cable-label">入場状態を更新</span>
          </div>
        </template>
      </div>
    </template>
    <template v-else-if="connect_status == consts.ACTION_CABLE.DEFAULT || connect_status == consts.ACTION_CABLE.CONNETED">
      <div class="pg-admissionlist__action_cable_status__status__disable">
        <template v-if="connect_status == consts.ACTION_CABLE.DEFAULT">
          <img v-bind:src="require('assets/images/synchronizing_gray.png')" class="pg-admissionlist__action_cable_status__status-icon" />
          <span class="pg-admissionlist__action_cable_status__action-cable-label__disable">同期準備中</span>
        </template>
        <template v-else-if="connect_status == consts.ACTION_CABLE.CONNETED">
          <img v-bind:src="require('assets/images/synchronizing_gray.png')" class="pg-admissionlist__action_cable_status__icon__synchronizing pg-admissionlist__action_cable_status__status-icon" />
          <span class="pg-admissionlist__action_cable_status__action-cable-label__disable">同期中</span>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import consts from '../utils/consts';

export default {
  props: {},
  data() {
    return {
      is_click_icon: false,
    };
  },

  computed: {
    connect_status: function () {
      return this.$store.getters['actioncable/connect_status'];
    },
    consts: function () {
      return consts;
    },
  },

  methods: {
    // ページ更新
    reload: function () {
      this.is_click_icon = true;
      location.reload();
    },
  },
};
</script>

<style scoped>
@import '../packs/application.css';

.pg-admissionlist__action_cable_status__status__disable {
  position: relative;
  padding: 7px 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  @media (max-width: 1140px) {
    margin-left: 20px;
  }
}

.pg-admissionlist__action_cable_status__action-cable-label__disable {
  color: #999;
  font-size: 13px;
  vertical-align: middle;
  font-weight: 700;
}

.pg-admissionlist__action_cable_status__status {
  position: relative;
  padding: 7px 10px;
  border: 1px solid #46506E;
  border-radius: 4px;
  @media (max-width: 1140px) {
    margin-left: 20px;
  }
}

.pg-admissionlist__action_cable_status__action-cable-label {
  color: #46506E;
  font-size: 13px;
  vertical-align: middle;
  font-weight: 700;
}

.pg-admissionlist__action_cable_status__status-icon {
  width: 12px;
  height: 16px;
}

.pg-admissionlist__action_cable_status__icon__synchronizing {
  -webkit-animation: icon-round 3s linear infinite;
  -moz-animation: icon-round 3s linear infinite;
  -ms-animation: icon-round 3s linear infinite;
  -o-animation: icon-round 3s linear infinite;
  animation: icon-round 3s linear infinite;
}

.clickable{
  cursor: pointer;
}

@-webkit-keyframes icon-round {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes icon-round {
  0% {
    -moz-transform: rotate(0deg);
  }
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-ms-keyframes icon-round {
  0% {
    -ms-transform: rotate(0deg);
  }
  100% {
    -ms-transform: rotate(360deg);
  }
}
@-o-keyframes icon-round {
  0% {
    -o-transform: rotate(0deg);
  }
  100% {
    -o-transform: rotate(360deg);
  }
}
@keyframes icon-round {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
